import { URL_FILES } from './envs'

export const MODEM_EQUIPMENTS_SUPPORT_URL = {
  ANDROID_TV: `${URL_FILES}suporte/ANDROID-MARCAS.pdf`,
  NOKIA: `${URL_FILES}suporte/DICAS-NOKIA-MARCAS.pdf`,
  HOMECAST: `${URL_FILES}suporte/HOMECAST-MARCAS.pdf`,
  FIBERHOME: `${URL_FILES}suporte/DICAS-FIBERHOME-MARCAS.pdf`,
  HUAWEI: `${URL_FILES}suporte/DICAS-HUAWEI-MARCAS.pdf`,
}

export const TECHNICAL_SUPPORT_PAGE_LABELS = {
  INTERNET: {
    name: 'Internet',
    items: [
      {
        urlFile: MODEM_EQUIPMENTS_SUPPORT_URL.FIBERHOME,
        name: 'Fiberhome',
        description: 'Procedimentos para equipamentos Fiberhome',
      },
      {
        urlFile: MODEM_EQUIPMENTS_SUPPORT_URL.NOKIA,
        name: 'Nokia',
        description: 'Procedimentos para equipamentos Nokia',
      },
      {
        urlFile: MODEM_EQUIPMENTS_SUPPORT_URL.HUAWEI,
        name: 'Huawei',
        description: 'Procedimentos para equipamentos Huawei',
      },
    ],
  },
  TELEPHONY: {
    name: 'Telefonia',
    items: [
      {
        urlFile: `${URL_FILES}telefonia/TELEFONIA.pdf`,
        name: 'Telefonia',
        description: 'Procedimentos para equipamentos de telefonia',
      },
    ],
  },
  TV: {
    name: 'TV',
    items: [
      {
        urlFile: `${URL_FILES}suporte/ANDROID-MARCAS.pdf`,
        name: 'Android TV',
        description: 'Procedimentos para equipamentos de Android TV',
      },
      {
        urlFile: `${URL_FILES}suporte/HOMECAST-MARCAS.pdf`,
        name: 'Home Cast',
        description: 'Procedimentos para equipamentos de Home Cast',
      },
    ],
  },
}
